import { Sprout, HeartPulse, Laptop, Route, Landmark, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const BUNGOMA =
  "https://images.unsplash.com/photo-1535756736290-ec9480a7eaf0?crop=entropy&cs=srgb&fm=jpg&q=85";

const PILLARS = [
  {
    icon: Sprout,
    num: "01",
    title: "Agricultural Revolution",
    text: "Fertilizer subsidy that works, sugarcane and maize value-addition, and agribusiness parks turning Bungoma's fertile land into county wealth.",
    span: "md:col-span-4",
    image: true,
    testid: "vision-pillar-agriculture",
  },
  {
    icon: HeartPulse,
    num: "02",
    title: "Universal Healthcare",
    text: "Modernized sub-county hospitals and equipped level-4 facilities in every region.",
    span: "md:col-span-2",
    testid: "vision-pillar-healthcare",
  },
  {
    icon: Laptop,
    num: "03",
    title: "Youth, TVET & Digital Jobs",
    text: "Expanded vocational TVETs, digital innovation hubs and county apprenticeship pipelines.",
    span: "md:col-span-2",
    testid: "vision-pillar-youth",
  },
  {
    icon: Route,
    num: "04",
    title: "Infrastructure & Trade",
    text: "Inter-county trade corridors, modern markets and rural roads that move produce to profit.",
    span: "md:col-span-2",
    testid: "vision-pillar-infrastructure",
  },
  {
    icon: Landmark,
    num: "05",
    title: "Transparent Governance",
    text: "An equal-opportunity CDF model, open county budgets and zero tolerance for graft.",
    span: "md:col-span-2",
    testid: "vision-pillar-governance",
  },
];

export const Vision = () => (
  <section id="vision" data-testid="vision-section" className="py-24 sm:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="eyebrow mb-4" data-testid="vision-eyebrow">Campaign Focus — Bungoma Governor 2027</p>
            <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08] max-w-3xl">
              A five-pillar transformation agenda for <span className="text-orange-500">Bungoma County.</span>
            </h2>
          </div>
          <p className="mono text-[11px] tracking-[0.2em] uppercase text-stone-500 max-w-xs leading-relaxed">
            Declared 2025 · Campaign secretariat established · General election August 2027
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-6 gap-5" data-testid="vision-bento-grid">
        {PILLARS.map((p, i) => (
          <Reveal key={p.num} delay={i * 0.07} className={p.span}>
            <div
              className={`bento-card group relative h-full overflow-hidden flex flex-col ${p.image ? "min-h-[340px] justify-end" : ""}`}
              data-testid={p.testid}
            >
              {p.image && (
                <>
                  <img
                    src={BUNGOMA}
                    alt="Bungoma County agricultural landscape"
                    className="absolute inset-0 w-full h-full object-cover opacity-40 transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C10] via-[#0B0C10]/55 to-transparent" />
                </>
              )}
              <div className="relative">
                <div className="flex items-center justify-between">
                  <p.icon size={22} className="text-orange-500" />
                  <span className="mono text-xs text-stone-600 font-semibold">{p.num}</span>
                </div>
                <h3 className="font-display font-bold text-xl sm:text-2xl mt-5 flex items-center gap-2">
                  {p.title}
                  <ArrowUpRight
                    size={18}
                    className="text-orange-500 opacity-0 -translate-x-1 translate-y-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0"
                  />
                </h3>
                <p className="text-sm sm:text-base text-stone-400 leading-relaxed mt-3">{p.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
